export default __webpack_public_path__ + "static/media/Python-logo-notext.svg.da2e6078.png";